/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ContactRestService, ContactType } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';

import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { mapSlicedDataItems, SlicedDataSource } from '@gh/core-data';

import { includes, size } from 'lodash';

import {
  contactFinderListFromSupplierListDto,
  ContactFinderListItem,
} from './contact-finder-list-item.model';

export interface ContactFinderDialogConfig extends FinderDialogConfig {
  type: ContactType;
  withAddress?: boolean;
}

@Injectable()
export class ContactFinderBusinessService implements InitDialogViewService<ContactFinderDialogConfig> {
  constructor(private contactRest: ContactRestService,
              private dictionaryService: DictionaryService) {

  }

  initDialogView(): any {
    return {
      contactTypes: this.dictionaryService.getByEnum(ContactType),
    };
  }

  findAllAsDataSource(types: ContactType[],
                      name: string,
                      withAddress: boolean = false): SlicedDataSource<ContactFinderListItem> {
    return this.canFindSuppliersWithAddressOnly(types, withAddress)
      ? <SlicedDataSource<ContactFinderListItem>>mapSlicedDataItems(
        this.contactRest.findAllSuppliersAsDataSource({ searchString: name }), contactFinderListFromSupplierListDto)
      : this.contactRest.findAllAsDataSource({
        types,
        name,
        autocomplete: true,
        showInactive: false,
      });
  }

  private canFindSuppliersWithAddressOnly(types: ContactType[], withAddress: boolean): boolean {
    return includes(types, ContactType.CreditorSupplier) && size(types) === 1 && withAddress;
  }
}
